module.exports = __webpack_public_path__ + "img/camila.f28fa50d.jpeg";